import {CheckCircle, Cancel, Edit, MoreVert, DirectionsRun} from "@mui/icons-material";
import {IconButton, Menu, MenuItem, Typography} from "@mui/material";
import React from "react";
import {Black, Green3, Grey17, Grey6, Red3} from "../../theme/styles";
import css_self from "../Navigation/css/NavBar.module.scss";
import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import EventBus from "../../util/EventBus";
import css_buttons from "../Common/css/CCButton.module.scss";
import AdminOrganizationPositionFormApplet from "../../eoec/applet/impl/Administration/AdminOrganizationPositionFormApplet";

class ETLJobTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("admin-position-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("admin-position-form-applet-save", this.onCancelHandler);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("admin-position-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("admin-position-form-applet-save", this.onCancelHandler);
    }

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        } else if (name === "Success Cell") {
            return this.renderSuccessCell;
        } else if (name === "Failure Cell") {
            return this.renderFailureCell;
        } else if (name === "Running Cell") {
            return this.renderRunningCell;
        }
        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Job") {
            this.props.navigate("/new-job");
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
        if (this.state.renderTarget === "New Position") {
           return <AdminOrganizationPositionFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="New" />;
        } else if (this.state.renderTarget === "Edit Position") {
           return <AdminOrganizationPositionFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Edit" />;
        }
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderSuccessCell = (___, params, __, _) => {
        let buffer;
        let color;
        if (this.state.fetchBackgroundOperation) {
            color = "#7B8291"
            buffer = this.state.previousBuffer
        } else {
            color = Green3
            buffer = this.state.buffer
        }

        if (params.row.id > buffer.length - 1) return;

        let content = buffer[params.row.id].get(params.field)

        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "left", alignContent: "center", height: "100%"}}>
                {content > 0 ? <CheckCircle sx={{color: color, width: "25px", height: "25px", margin: "auto 0 auto 0"}} /> : null}
                <Typography style={{fontSize: "14px", margin: content > 0 ? "auto 0 auto 5px" : "auto 0 auto 30px", color: this.state.fetchBackgroundOperation ? "#7B8291" : Black}}>{content}</Typography>
            </div>
        )
    };

    renderRunningCell = (___, params, __, _) => {
        let buffer;
        let color;
        if (this.state.fetchBackgroundOperation) {
            color = "#7B8291"
            buffer = this.state.previousBuffer
        } else {
            color = Green3
            buffer = this.state.buffer
        }

        if (params.row.id > buffer.length - 1) return;

        let content = buffer[params.row.id].get(params.field)

        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "left", alignContent: "center", height: "100%"}}>
                {content > 0 ? <DirectionsRun sx={{color: color, width: "25px", height: "25px", margin: "auto 0 auto 0"}} /> : null}
                <Typography style={{fontSize: "14px", margin: content > 0 ? "auto 0 auto 5px" : "auto 0 auto 30px"}}>{content}</Typography>
            </div>
        )
    };

    renderFailureCell = (___, params, __, _) => {
        let buffer;
        let color;
        if (this.state.fetchBackgroundOperation) {
            color = "#7B8291"
            buffer = this.state.previousBuffer
        } else {
            color = Red3
            buffer = this.state.buffer
        }

        if (params.row.id > buffer.length - 1) return;

        let content = buffer[params.row.id].get(params.field)

        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "left", alignContent: "center", height: "100%"}}>
                {content > 0 ? <Cancel sx={{color: color, width: "25px", height: "25px", margin: "auto 0 auto 0"}} /> : null}
                <Typography style={{fontSize: "14px", margin: content > 0 ? "auto 0 auto 5px" : "auto 0 auto 30px"}}>{content}</Typography>
            </div>
        )
    };

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-9px", paddingLeft: "8px", marginRight: "auto", marginTop: "auto", marginBottom: "auto", height: "100%"}}>
                <IconButton className={css_buttons.blueIconButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Edit Position"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit Position</Typography>
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(ETLJobTable)));